// Module
var code = "<div class=\"tabcontrol\"> <ul class=\"tab-list\"> <li class=\"tab-list-elem\" v-for=\"tab in tabs\" :data-tab=\"tab.tabData\" :class=\"{ 'active' : tab.isActive }\" @click=\"selectTab(tab)\">{{ tab.name }}</li> </ul> <slot></slot> </div>";
// Exports
module.exports = code;